import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputGroup } from './InputGroup.entity';

export class MutateTextModuleGroups<T extends EMode = EMode.entity> {
  /** Alias: structure */
  structure?: InputGroup<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<MutateTextModuleGroups> = {
  structure: {
    alias: 'structure',
  },
  __typename: {
    alias: '__typename',
  },
};

export const mutateTextModuleGroupsEntityDefinition: EntitiyDefinition<MutateTextModuleGroups> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'MutateTextModuleGroups',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
